import { Directive, Input, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[qtColumnDef]',
  standalone: false,
})
export class ColumnDefDirective {
  private templateRef = inject<TemplateRef<any>>(TemplateRef);

  @Input('qtColumnDef') id: string;

  template = this.templateRef;
}
